/* eslint-disable no-redeclare */
import {
  HealthcareSessionId,
  HealthcareUserId,
  ProductType,
} from '@hc-frontend/core-types';
import { z } from 'zod';

/**
 * Parameters for setting the product type on a Lead Storage prospect.
 *
 * Used by landing pages, which have no journey and therefore never reach
 * `updateProspectJourney`, so the prospect would otherwise stay without a
 * `productTypeId`.
 */
export const UpdateProspectProductTypeParameters = z.object({
  sessionId: HealthcareSessionId,
  userId: HealthcareUserId,
  productType: ProductType,
});

/**
 * Parameters for setting the product type on a Lead Storage prospect.
 */
export type UpdateProspectProductTypeParameters = z.infer<
  typeof UpdateProspectProductTypeParameters
>;
